import '../Assets/css/banner.css';

export const Banner = () => {
    return (
        <div className="banner">
            <div className="banner-container">
                <p className="banner-text">
                    La solución al transporte de personal en la Gran Minería
                </p>
            </div>
        </div>
    )
}